<div class="ticket">
    <ion-item class="header" [color]="color" lines="none">
        <ion-label>{{ tr('@place_receipt_title') }}</ion-label>
    </ion-item>
    <upp-scrollable class="guest-panel-scroll paper" [scrollbar]="'none'">
        <upp-ticket-print uppDataid="guestpreview-ticket-print" [ticket]="ticket" [display]="true"></upp-ticket-print>
        <div class="preview-spacer"></div>
    </upp-scrollable>
    <div class="form-buttons">
        <ion-button uppDataid="guestpreview-ticket-done"
            [color]="color"
            size="large"
            expand="full"
            (click)="OnDone()"
        >
            {{ tr('@place_receipt_done') }}
        </ion-button>
    </div>
</div>
